module.exports = __webpack_public_path__ + "static/media/web_page_home.e752685d.png";